module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "primary"
  }, [_c('v-layout', {
    staticClass: "justify-space-around"
  }, [_c('v-flex', [_c('h4', {
    staticClass: "white--text"
  }, [_vm._v("Compras")])]), _vm._v(" "), _c('v-flex', [(_vm.edit) ? _c('v-btn', {
    staticClass: "yellow",
    attrs: {
      "fab": "",
      "dark": ""
    },
    on: {
      "click": _vm.cambiaredit
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-form', [_c('v-layout', {
    staticClass: "justify-space-around",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-menu', [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "name": "fecha_factura",
      "label": "Fecha Factura",
      "prepend-icon": "date_range",
      "value": _vm.compra.fecha_facturacion,
      "disabled": _vm.edit
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es"
    },
    model: {
      value: (_vm.compra.fecha_facturacion),
      callback: function($$v) {
        _vm.$set(_vm.compra, "fecha_facturacion", $$v)
      },
      expression: "compra.fecha_facturacion"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-menu', [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "name": "fecha_ingreso",
      "label": "Fecha Ingreso",
      "prepend-icon": "date_range",
      "value": _vm.compra.fecha_ingreso,
      "disabled": _vm.edit
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es"
    },
    model: {
      value: (_vm.compra.fecha_ingreso),
      callback: function($$v) {
        _vm.$set(_vm.compra, "fecha_ingreso", $$v)
      },
      expression: "compra.fecha_ingreso"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm3": "",
      "mr-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "required": "",
      "name": _vm.documento,
      "label": "No.Documento",
      "disabled": _vm.edit
    },
    model: {
      value: (_vm.compra.numerodocumento),
      callback: function($$v) {
        _vm.$set(_vm.compra, "numerodocumento", $$v)
      },
      expression: "compra.numerodocumento"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "required": "",
      "label": "Serie",
      "name": "serie",
      "disabled": _vm.edit
    },
    model: {
      value: (_vm.compra.serie),
      callback: function($$v) {
        _vm.$set(_vm.compra, "serie", $$v)
      },
      expression: "compra.serie"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "disabled": _vm.edit,
      "name": "proveedores",
      "items": _vm.proveedores,
      "item-text": "nombre",
      "item-value": "id",
      "label": "Proveedor",
      "autocomplete": ""
    },
    model: {
      value: (_vm.compra.proveedor),
      callback: function($$v) {
        _vm.$set(_vm.compra, "proveedor", $$v)
      },
      expression: "compra.proveedor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "cantidad",
      "label": "Cantidad",
      "disabled": _vm.edit
    },
    model: {
      value: (_vm.compra.cantidad),
      callback: function($$v) {
        _vm.$set(_vm.compra, "cantidad", $$v)
      },
      expression: "compra.cantidad"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "cantidad2",
      "label": "total calculado",
      "disabled": true
    },
    model: {
      value: (_vm.compra.totalc),
      callback: function($$v) {
        _vm.$set(_vm.compra, "totalc", $$v)
      },
      expression: "compra.totalc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "xs9": "",
      "sm3": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Pagada"
    },
    on: {
      "change": function($event) {
        return _vm.cambio(_vm.compra.pagada)
      }
    },
    model: {
      value: (_vm.compra.pagada),
      callback: function($$v) {
        _vm.$set(_vm.compra, "pagada", $$v)
      },
      expression: "compra.pagada"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Crédito"
    },
    on: {
      "change": function($event) {
        return _vm.cambio2(_vm.compra.credito)
      }
    },
    model: {
      value: (_vm.compra.credito),
      callback: function($$v) {
        _vm.$set(_vm.compra, "credito", $$v)
      },
      expression: "compra.credito"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-space-between "
  }, [(!_vm.compra.id) ? _c('v-btn', {
    staticClass: "ma-2 primary",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.crearCompra(_vm.compra)
      }
    }
  }, [_vm._v("Guardar")]) : _vm._e(), _vm._v(" "), (_vm.compra.id) ? _c('v-btn', {
    staticClass: "ma-2 primary",
    attrs: {
      "dark": "",
      "disabled": _vm.edit
    },
    on: {
      "click": function($event) {
        return _vm.actualizarcompra(_vm.compra)
      }
    }
  }, [_vm._v("Modificar")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2 red",
    attrs: {
      "dark": ""
    },
    on: {
      "click": _vm.regresar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), (_vm.compra.id) ? _c('v-btn', {
    staticClass: "success",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.actualizardialog(true)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add_shopping_cart")])], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return undefined
      }
    }]),
    model: {
      value: (_vm.dialogo),
      callback: function($$v) {
        _vm.dialogo = $$v
      },
      expression: "dialogo"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "indigo"
  }, [_c('v-flex', [_c('h4', {
    staticClass: "white--text"
  }, [_vm._v("Linea Compra")])])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    staticClass: "justify-space-between wrap"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "disabled": !_vm.edit,
      "name": "Producto",
      "search-input": _vm.sproducto,
      "items": _vm.productos,
      "item-text": "producto",
      "item-value": "id",
      "label": "Producto:",
      "autocomplete": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.sproducto = $event
      },
      "update:search-input": function($event) {
        _vm.sproducto = $event
      },
      "input": function($event) {
        return _vm.cambiarprecio(_vm.lineacompra.producto)
      }
    },
    model: {
      value: (_vm.lineacompra.producto),
      callback: function($$v) {
        _vm.$set(_vm.lineacompra, "producto", $$v)
      },
      expression: "lineacompra.producto"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "cantidad",
      "label": "Cantidad"
    },
    model: {
      value: (_vm.lineacompra.cantidad),
      callback: function($$v) {
        _vm.$set(_vm.lineacompra, "cantidad", $$v)
      },
      expression: "lineacompra.cantidad"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "Precio",
      "label": "Precio",
      "hidden": ""
    },
    model: {
      value: (_vm.lineacompra.precio),
      callback: function($$v) {
        _vm.$set(_vm.lineacompra, "precio", $$v)
      },
      expression: "lineacompra.precio"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "Precio",
      "label": "Precio Anterior",
      "disabled": true,
      "hidden": ""
    },
    model: {
      value: (_vm.lineacompra.precio_compra),
      callback: function($$v) {
        _vm.$set(_vm.lineacompra, "precio_compra", $$v)
      },
      expression: "lineacompra.precio_compra"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "fecha_vencimiento",
      "label": "Fecha de vencimiento (obligatoria si maneja lotes)",
      "type": "date"
    },
    model: {
      value: (_vm.lineacompra.fecha_vencimiento),
      callback: function($$v) {
        _vm.$set(_vm.lineacompra, "fecha_vencimiento", $$v)
      },
      expression: "lineacompra.fecha_vencimiento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "disabled": !_vm.edit,
      "name": "Presentacion",
      "items": _vm.presentaciones,
      "item-text": "presentacion",
      "item-value": "id",
      "label": "Presentación:",
      "autocomplete": ""
    },
    model: {
      value: (_vm.lineacompra.presentacion),
      callback: function($$v) {
        _vm.$set(_vm.lineacompra, "presentacion", $$v)
      },
      expression: "lineacompra.presentacion"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-action', [_c('v-btn', {
    staticClass: "ma-2 primary",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.crearLineaCompra(_vm.lineacompra)
      }
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2 red",
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.actualizardialog(false)
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.compra.detallescompratemporal,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-btn', {
          staticClass: "red--text text--darken-2",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.eliminar(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.producto_name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.cantidad))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.subtotal))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.presentacion_producto))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.fecha_vencimiento || ''))])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a0a97e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ComprasAdd.vue
// module id = 425
// module chunks = 1